// @flow
import type { Map as ImmutableMap, List as ImmutableList } from 'immutable';
import { getDayScheduleEvents, getSelectedDay, getSelectedEvent } from '~/core/state/ui/schedule/selectors';

import { connect } from 'react-redux';
import { getAppSetting } from '~/core/state/app-settings/selectors';
import { SCHEDULE_STOP_TOOLTIP } from '~/core/constants/app-settings';
import Tooltip from './component';

type OwnProps = {
    componentId: string
};

type StateProps = OwnProps & {
    nextEventStart?: number,
    numEventsInSelectedDay?: number,
    selectedDay?: ?number,
    selectedEvent?: ?ImmutableMap<*, *>,
    showToolTip: boolean
};

const mapStateToProps = (state: any, ownProps: OwnProps): StateProps => {
    const { componentId } = ownProps;
    const scheduleStopTooltip = getAppSetting(state, SCHEDULE_STOP_TOOLTIP);
    const selectedEvent: ?ImmutableMap<*, *> = scheduleStopTooltip ? null : getSelectedEvent(state, { componentId });

    if (scheduleStopTooltip || !selectedEvent || (selectedEvent && selectedEvent.size === 0)) {
        return {
            ...ownProps,
            showToolTip: false
        };
    }

    const selectedDay = getSelectedDay(state, { componentId });

    const dayEvents: ImmutableList<*> = getDayScheduleEvents(state, {
        componentId,
        dayIndex: selectedDay
    });

    const numEventsInSelectedDay = dayEvents.size;
    const nextEventIndex =
        selectedEvent && selectedEvent.get('dayIndex') === selectedDay ? selectedEvent.get('eventIndex') + 2 : 1;
    const nextEventStart = dayEvents && dayEvents.getIn([nextEventIndex, 'start'], 1440);

    return {
        ...ownProps,
        nextEventStart,
        numEventsInSelectedDay,
        selectedDay,
        selectedEvent,
        showToolTip: true
    };
};

export default connect(mapStateToProps)(Tooltip);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/tooltip/index.js